import React, { useState, useEffect } from 'react';
import { CustomButton } from '../shared/customButton';
import { CustomTextField } from '../shared/customTextField';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import styles from './EmailVerify.module.scss';
import { CustomAlertBox } from '../shared/customAlertBox';
import { verifyVerificationCode, getAccessToken, resendVerificationCode, getEmailAddress } from '../../services/util/auth';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';

const EmailVerify = (props) => {
    const [isLoading, setStatus] = useState(false);
    const [isReCodeLoading, setReCodeStatus] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let history = useHistory();

    const schema = yup.object({
        code: yup.string().test('Digits only', 'The field should have digits only', (value) => /^\d+$/.test(value)).required('Required')
    });

    const formFocus = () => {
        setShow(false);
    }

    const resendCode = async () => {
        if (isReCodeLoading === false) {
            setReCodeStatus(true);
            const token = getAccessToken();
            let respond = await resendVerificationCode(token)
            if (respond.success === true) {
                setReCodeStatus(false);
            } else {
                setReCodeStatus(false);
                setMessage(respond.msg);
                setShow(true);
            }
        }

    }

    const onSubmit = async (values) => {
        setStatus(true);
        let respond = await verifyVerificationCode(values.code)
        if (respond.success === true) {
            setStatus(false);
            history.push('/company');
        } else {
            setStatus(false);
            setMessage(respond.msg);
            setShow(true);
        }

    }

    const checkIsAccountActivated = () => {
        let isActivated = ((window.localStorage.getItem('activated')) == 'true');
        if (isActivated === true) {
            history.push('/company');
        }
    }

    useEffect(() => {
        checkIsAccountActivated();
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_STATIC_GOOGLE_ANALYTICS_ID}`,
            gaOptions: { name: 'trackerStatic' }
        }, {
            trackingId: `${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`,
            gaOptions: { name: 'trackerApp' }
        }]);

        ReactGA.pageview(window.location.pathname + window.location.search, ['trackerApp', 'trackerStatic']);
    }, [])

    return (
        <div>
            <Helmet>
                <title>Email Verify | HireTrace</title>
            </Helmet>
            <Row className={styles.mainRowSignup}>
                <Col xs={12} md={6} className={styles.leftBar}>
                    <Container>
                        <Col className={styles.topicColumn}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 40C25.4247 40 40 25.4247 40 0C40 25.4247 54.5753 40 80 40C54.5753 40 40 54.5753 40 80C40 54.5753 25.4247 40 0 40Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C7.62742 12 12 7.62742 12 0C12 7.62742 16.3726 12 24 12C16.3726 12 12 16.3726 12 24C12 16.3726 7.62742 12 0 12Z" fill="#FEC84B" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M64 24C69.0849 24 72 21.0849 72 16C72 21.0849 74.9151 24 80 24C74.9151 24 72 26.9151 72 32C72 26.9151 69.0849 24 64 24Z" fill="#FEC84B" />
                            </svg>
                            <p className={styles.topicDesc}>
                                Start your Free Trial                               
                            </p>
                            <p className={styles.secondDesc}>Create a free account and get full access to all features for <br /> 14-days. No credit card needed. Get started in 2 minutes.</p>
                        
                        </Col>
                        <Col className={styles.bottomColum}>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_1.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_2.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_3.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_4.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userImageDiv}>
                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_5.png`} rounded fluid className={styles.companyLogo} />
                            </div>
                            <div className={styles.userTexteDiv}>
                                <p className={styles.bottomDesc}>Join 5,000+ Talent Professionals</p>
                            </div>

                        </Col>
                    </Container>
                </Col>
                <Col xs={12} md={6}>
                    <Container className={styles.mainContainer}>
                        <Row>
                            <Col className={styles.leftColumnMain}>
                                <div className={styles.companySecondLogoDiv}>
                                    <a href="/" target="_blank" rel="noreferrer">
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                    </a>
                                </div>
                                <div className={styles.companyLogoTextDiv}>
                                    <p>Hiretrace</p>
                                </div>
                            </Col>
                            <Col className={styles.rightColumnMain}>
                                <p className={styles.rightColumnTopText}>Have an account?</p>
                                <Link to="/signin" className={styles.rightColumnTopSecondText}>
                                    Log in
                                </Link>
                            </Col>
                        </Row>
                        <Container>
                            <Row className={styles.formRow}>
                                <Col sm={10} xl={6}>
                                    <Row>
                                        <Col className='m-0 p-0'>
                                            <h3 className={styles.boxTopic}>Email Verification</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="m-0 p-0 text-left">
                                            <p><span className={styles.boxdescription}>We have sent you a 6 digit verification code to <b>{getEmailAddress() ? getEmailAddress() : null}</b>. Please enter it below.</span></p>
                                        </Col>
                                    </Row>
                                    
                                    <Row className={styles.alertRow}>
                                        <Col className={styles.alertColumn}>
                                            <CustomAlertBox alertBodyText={'Your verification email might be in spam or junk folder'} alertType='warningAlert'/>
                                        </Col>
                                    </Row>
                                    {show === true &&
                                        <div className={styles.formDivRow}>
                                            {show === true ? (<CustomAlertBox alertBodyText={message} alertType='dangerAlert'/>) : ''}
                                        </div>
                                    }
                                    <Row>
                                        <Col className='p-0'>
                                            <Formik
                                                validationSchema={schema}
                                                onSubmit={(values) => onSubmit(values)}
                                                initialValues={{}}>
                                                {({
                                                    errors,
                                                    handleChange,
                                                    handleSubmit,
                                                    submitCount
                                                }) => (
                                                    <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                        <Col className='m-0 p-0'>
                                                            <CustomTextField
                                                                label='6-digit verification code'
                                                                placeholder="Enter 6 Digit Code"
                                                                classLabel="defaultLabel"
                                                                handleOnChange={handleChange}
                                                                name="code"
                                                                type="text"
                                                                classType="defaultTextBox"
                                                                errorMessage={errors.code}
                                                                isInvalid={submitCount > 0 && !!errors.code}
                                                            />
                                                        </Col>
                                                        <Col sm={12} className='mt-4 p-0'>
                                                            <CustomButton
                                                                buttonType="submit"
                                                                label="Verify"
                                                                type="primaryBtn"
                                                                disabled={isLoading === true ? true : false}
                                                                backicon=
                                                                {isLoading === true ?
                                                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                                    : ''
                                                                }
                                                            />
                                                        </Col>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                    <Row className={styles.resendTextRow}>
                                        <span><p className={styles.resendText}>Didn't receive?<span className={styles.resendLink} onClick={() => resendCode()}>Resend {isReCodeLoading === true && <i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i>}</span></p></span>
                                    </Row>
                                    {/* <Row>
                                        <div className={styles.verificateNoteBBox}>
                                            <Col className="text-left mt-3">
                                                <p className={styles.spamMsg}> <svg data-tip data-for={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#D2A20E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> &nbsp;Please check your verification code in spam or junk email folder</p>
                                            </Col>
                                        </div>
                                    </Row> */}
                                </Col>
                            </Row>
                        </Container>
                        <Row className={styles.bottomRow}>
                            <Col>
                            </Col>
                            <Col>
                                <div className={styles.helpEmailDiv}>
                                    <svg className={styles.emailIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M1.33334 4.66669L6.77662 8.47698C7.2174 8.78553 7.43779 8.9398 7.67752 8.99956C7.88927 9.05234 8.11075 9.05234 8.3225 8.99956C8.56223 8.9398 8.78262 8.78553 9.2234 8.47698L14.6667 4.66669M4.53334 13.3334H11.4667C12.5868 13.3334 13.1468 13.3334 13.5747 13.1154C13.951 12.9236 14.2569 12.6177 14.4487 12.2413C14.6667 11.8135 14.6667 11.2535 14.6667 10.1334V5.86669C14.6667 4.74658 14.6667 4.18653 14.4487 3.75871C14.2569 3.38238 13.951 3.07642 13.5747 2.88467C13.1468 2.66669 12.5868 2.66669 11.4667 2.66669H4.53334C3.41324 2.66669 2.85319 2.66669 2.42536 2.88467C2.04904 3.07642 1.74308 3.38238 1.55133 3.75871C1.33334 4.18653 1.33334 4.74658 1.33334 5.86669V10.1334C1.33334 11.2535 1.33334 11.8135 1.55133 12.2413C1.74308 12.6177 2.04904 12.9236 2.42536 13.1154C2.85319 13.3334 3.41324 13.3334 4.53334 13.3334Z" stroke="#667085" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p className={styles.helpText}>© Hiretrace 2023</p>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            {/* <Row className={styles.emailVerifyBackgroundColor}>
                <Container>
                    <Row>
                        <Col xs={{ span: 10, offset: 1 }} md={{ span: 6, offset: 3 }} >
                            <div className={styles.emailVerifyBox}>
                                <Col sm={{ span: 10, offset: 1 }} className={styles.companyLogoDiv}>
                                    <a href="/" target="_blank" rel="noreferrer">
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/companylogo.png`} rounded fluid className={styles.companyLogo} />
                                    </a>
                                </Col>
                                <Container className={styles.innerBoxContainer}>
                                    <Row>
                                        <Col>
                                            <h3 className={styles.boxTopic}>Email Verification</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{ span: 8, offset: 2 }} className="text-left">
                                            <p><span className={styles.boxdescription}>We have sent you a 6 digit verification code to <b>{getEmailAddress() ? getEmailAddress() : null}</b>. Please enter it below. Didn’t receive?&nbsp;&nbsp; </span>{isReCodeLoading === true ? <span className={styles.boxLinkDisabled}>Resend<i className={`${"fas fa-spinner fa-spin"} ${styles.loadingIcon}`}></i></span> : <span className={styles.boxLink} onClick={() => resendCode()}>Resend</span>}</p>
                                        </Col>
                                    </Row>
                                    {show === true &&
                                        <Col sm={{ span: 8, offset: 2 }}>
                                            {show === true ? (<AlertBox alertMessage={message} />) : ''}
                                        </Col>
                                    }
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={(values) => onSubmit(values)}
                                        initialValues={{}}>
                                        {({
                                            errors,
                                            handleChange,
                                            handleSubmit,
                                            submitCount
                                        }) => (
                                            <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                <Col sm={{ span: 8, offset: 2 }}>

                                                    <Col sm={{ span: 8, offset: 2 }} className={styles.codeTextBox}>
                                                        <Form.Group className={styles.formText} controlId={props.controlId}>
                                                            <Form.Control
                                                                className={styles.defaultTextBox}
                                                                placeholder="Enter 6 Digit Code"
                                                                onChange={handleChange}
                                                                name="code"
                                                                type="text"
                                                                isInvalid={submitCount > 0 && !!errors.code}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.code}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>

                                                    {<CustomButton
                                                        buttonType="submit"
                                                        label="Verify"
                                                        type="primaryBtn"
                                                        disabled={isLoading === true ? true : false}
                                                        backicon=
                                                        {isLoading === true ?
                                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                            : ''
                                                        }

                                                    />}

                                                </Col>
                                            </Form>
                                        )}
                                    </Formik>
                                    warning msg for check spam folder
                                    <Row>
                                        <Col sm={{ span: 8, offset: 2 }} className="text-left mt-3">
                                            <p className={styles.spamMsg}> <svg data-tip data-for={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#D2A20E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> &nbsp;Please check your verification code in spam or junk email folder</p>
                                        </Col>
                                    </Row>

                                </Container>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row> */}
        </div >
    )
}

export default EmailVerify;